// extracted by mini-css-extract-plugin
export default {"address":"GBbXmg","field":"dllQmx"};